import Vue from 'vue'
import axios from "axios";

const PaxConnectApi = {
    addOfferToOffice: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun vom Server auf Ihr Reisebüro TV - Gerät übertragen.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/addOfferImage?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    onGetError: function (e) {
        console.error(e)
    },
    prepareLogin: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun auf dem Server zur Voransicht aufbereitet.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        reqData['time'] = new Date().getTime()
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/prepareLogin'
        axios({
            method: 'post',
            url: url,
            params: reqData,
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    if (cmp) {
                        cmp.onGetError(error)
                    }
                }
            })
    },
    requestOfferImage: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun auf dem Server zur Voransicht aufbereitet.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/createOfferImage?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    updateMode: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Editor wird gestartet.<br>Bitte warten Sie einen Moment.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/updateMode?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
    getOffer: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle({
            show: true, text: 'Die gewählten Inhalte werden nun auf dem Server zur Voransicht aufbereitet.<br>Das kann einige Zeit dauern.'
        })
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/pckermax/getOffer?time=' + new Date().getTime()
        axios({
            method: 'post',
            url: url,
            params: {
                time: new Date().getTime()
            },
            data: reqData,
            responseType: 'json'
        })
            .then(function (response) {
                Vue.prototype.$api.hideIdle()
                if (fnOk) {
                    fnOk(response.data)
                }
            })
            .catch(error => {
                console.log(error.response)
                Vue.prototype.$api.hideIdle()
                if (fnFailed) {
                    fnFailed(error.response)
                } else {
                    cmp.onGetError(error)
                }
            })
    },
}


export default PaxConnectApi
